module.exports = __webpack_public_path__ + "static/img/img.92b2d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.png
// module id = 568
// module chunks = 1